import { handleActions } from "redux-actions";
import {
  getRangeOptions,
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";
import {
  FETCH_ALL_LOCATIONS_TABLES_SUCCESS,
  FETCH_ALL_LOCATIONS_DATA_SUCCESS,
  FETCH_OVERVIEW_TABLE_SUCCESS,
  FETCH_FILTERS_UPDATE_SUCCESS,
  FETCH_OVERVIEW_DATA_SUCCESS,
  FETCH_SCORECARDS_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES,
  SET_SECOND_LEVEL_FILTERS_LOADING,
  SET_FOURTH_LEVEL_FILTERS_LOADING,
  SET_MORE_LOCATIONS_TABLE_LOADING,
  SET_THIRD_LEVEL_FILTERS_LOADING,
  UPDATE_GROUP_BY,
  SET_ALL_LOCATION_TABLES_LOADING,
  SET_SELECTED_RANGE_OPTION,
  SET_FILTERS_DIRTY,
  SET_TABLES_LOADING,
  SET_LOADING,
  SET_DATES,
  UPDATE_SELECTED_FIRST_LEVEL_FILTERS,
  UPDATE_SELECTED_SECOND_LEVEL_FILTERS,
  UPDATE_SELECTED_THIRD_LEVEL_FILTERS,
  UPDATE_SELECTED_FOURTH_LEVEL_FILTERS,
  UPDATE_SELECTED_FIFTH_LEVEL_FILTERS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  CLEAR_ALL_LOCATIONS_TABLE_DATA,
  CLEAR_RANGE_OPTIONS,
  CLEAR_ALL_LOCATIONS_TABLES
} from "./multiLocationOverviewSaga";

const initialState = {
  currentUser: {},
  selectedRequestDates: {},
  selectedLevelFirst: [],
  selectedLevelSecond: [],
  selectedLevelThird: [],
  selectedLevelFourth: [],
  selectedLevelFifth: [],
  overviewTableData: {},
  groupBy: {
    label: "Group by",
    value: {
      name: "Location",
      id: "location_name"
    },
    filters: [
      {
        name: "Location",
        id: "location_name"
      }
    ]
  },
  allLocationsTableData: [],
  allLocationsData: {
    tableInfo: {
      colHeaders: []
    }
  },
  scorecards: [],
  isLoading: true,
  haveRequestError: false,
  filtersLoading: false,
  filtersDirty: false,
  tablesLoading: false,
  breakdownTableLabel: "Location",
  secondLevelFiltersLoading: false,
  thirdLevelFiltersLoading: false,
  fourthLevelFiltersLoading: false,

  availableFilters: {
    level_1: {},
    level_2: {},
    level_3: {},
    level_4: {},
    level_5: {}
  },

  allLocationsTablesLoading: true,
  loadMoreLocationsLoading: false,
  loadMoreLocationsNumber: 10,
  currentlyLoadedLocationsNumber: 0,
  selectedRangeOption: {},
  rangeOptions: []
};

export function pushLocationsData(state, payload) {
  let data = state.allLocationsTableData;
  data.push({ name: payload.name, data: payload.data });
  return data;
}

export function setRangeOptions(options, action) {
  let allOptions = options;

  allOptions.push({
    id: 999,
    name: "Custom Range",
    startDate: action.payload.startDate,
    endDate: action.payload.endDate
  });

  return allOptions;
}

function getObjectForFilters(state, action) {
  return {
    ...state,
    availableFilters: action.payload.filters || state.availableFilters,
    groupBy: {
      ...state.groupBy,
      ...(action.payload.group_by || state.groupBy)
    },
    selectedLevelFirst: action.payload.filters.level_1,
    selectedLevelSecond: action.payload.filters.level_2,
    selectedLevelThird: action.payload.filters.level_3,
    selectedLevelFourth: action.payload.filters.level_4,
    selectedLevelFifth: action.payload.filters.level_5.filter((elem) => elem.checked)
  };
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload,
      haveRequestError: false
    }),
    [FETCH_ALL_LOCATIONS_DATA_SUCCESS]: (state, action) => ({
      ...state,
      allLocationsData: action.payload
    }),
    [CLEAR_ALL_LOCATIONS_TABLES]: (state, action) => ({
      ...state,
      allLocationsTableData: action.payload
    }),
    [CLEAR_RANGE_OPTIONS]: (state) => ({
      ...state,
      rangeOptions: getRangeOptions(undefined),
      filtersDirty: false
    }),
    [SET_MORE_LOCATIONS_TABLE_LOADING]: (state, action) => ({
      ...state,
      loadMoreLocationsLoading: action.payload
    }),
    [SET_ALL_CURRENTLY_LOADED_LOCATION_TABLES]: (state, action) => ({
      ...state,
      currentlyLoadedLocationsNumber: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_TABLES_LOADING]: (state, action) => ({
      ...state,
      tablesLoading: action.payload
    }),
    [SET_SECOND_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      secondLevelFiltersLoading: action.payload
    }),
    [SET_THIRD_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      thirdLevelFiltersLoading: action.payload
    }),
    [SET_FOURTH_LEVEL_FILTERS_LOADING]: (state, action) => ({
      ...state,
      fourthLevelFiltersLoading: action.payload
    }),
    [SET_ALL_LOCATION_TABLES_LOADING]: (state, action) => ({
      ...state,
      allLocationsTablesLoading: action.payload
    }),
    [CLEAR_ALL_LOCATIONS_TABLE_DATA]: (state) => ({
      ...state,
      allLocationsTableData: []
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [UPDATE_GROUP_BY]: (state, action) => ({
      ...state,
      filtersDirty: true,
      groupBy: {
        ...state.groupBy,
        value: action.payload
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [SET_SELECTED_RANGE_OPTION]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [FETCH_ALL_LOCATIONS_TABLES_SUCCESS]: (state, action) => ({
      ...state,
      allLocationsTableData: pushLocationsData(state, action.payload)
    }),
    [FETCH_OVERVIEW_DATA_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_OVERVIEW_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      overviewTableData: action.payload,
      breakdownTableLabel: state.groupBy.value.name
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...getObjectForFilters(state, action)
    }),
    [FETCH_FILTERS_UPDATE_SUCCESS]: (state, action) => ({
      ...state,
      availableFilters: action.payload.filters || state.availableFilters
    }),
    [FETCH_SCORECARDS_SUCCESS]: (state, action) => ({
      ...state,
      scorecards: action.payload
    }),
    [UPDATE_SELECTED_FIRST_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelFirst: action.payload || state.selectedLevelFirst,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_SECOND_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelSecond: action.payload || state.selectedLevelSecond,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_THIRD_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelThird: action.payload || state.selectedLevelThird,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_FOURTH_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelFourth: action.payload || state.selectedLevelFourth,
      filtersDirty: true
    }),
    [UPDATE_SELECTED_FIFTH_LEVEL_FILTERS]: (state, action) => ({
      ...state,
      selectedLevelFifth: action.payload || state.selectedLevelFifth,
      filtersDirty: true
    })
  },
  initialState
);
